/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreRdsSubnetGroupsRdsSubnetGroupsInner } from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner';

export class RestoreRdsSubnetGroups {
  /**
  * The region to restore
  */
  'region': string;
  /**
  * The rds subnets groups for the region
  */
  'rdsSubnetGroups': Array<RestoreRdsSubnetGroupsRdsSubnetGroupsInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "rdsSubnetGroups",
      "baseName": "rdsSubnetGroups",
      "type": "Array<RestoreRdsSubnetGroupsRdsSubnetGroupsInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreRdsSubnetGroups.attributeTypeMap;
  }

  public constructor() {
  }
}

